export * from './gs-area-material.component';
